/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import React, { useMemo, useState } from 'react'
import { Icon } from "@blueprintjs/core";
import { Colors } from 'styles/variables';

/**
 * Simple star rating component.
 *
 * @param starCount the total number of stars to show
 * @param starValue the current rating
 * @param clickStar if set, this will fire the given event, else this is not interactive
 * @param starColor color the stars // why not with css?
 * @returns {*}
 * @constructor
 */
export const Stars = ({ starCount = 5, starValue = 0, clickStar, starColor = Colors.BLUE1 }) => {
	const selectable = useMemo(() => { return !!clickStar }, [clickStar]);

	const [value, setValue] = useState(starValue);
	const [hover, setHover] = useState(-1);
	const stars = useMemo(() => Array.from({ length: starCount }, (v, i) => i), [starCount]);

	return (
		<div className="stars">
			{[...stars].map((n, i) => {
				const selected = hover > -1 ? hover >= i : i < value;
				const vars = {
					className: selected ? "star selected" : "star unselected",
					icon: selected ? "star" : "star-empty"
				}

				return (
					<Icon
						key={i}
						className={vars.className}
						css={css` color: ${starColor};`}
						icon={vars.icon}
						onClick={() => {
							if (i + 1 !== value) {
								setValue(i + 1);
								clickStar(i + 1);
							}
						}}
						onMouseOver={() => selectable && setHover(i)}
						onMouseOut={() => selectable && setHover(-1)}
					/>
				)
			})}
		</div>
	)
};
